export default __webpack_public_path__ + "static/media/browse_what_you_like.24fe15c6.svg";